export const buildStoryblokUrl = (
	path: string,
	folder?: string | null
): string => {
	// Remove leading/trailing slashes and 'cdn/stories' prefix if already present
	const cleanPath = path
		.replace(/^\/+|\/+$/g, "")
		.replace(/^cdn\/stories\//, "");
	const folderPath = folder ? `${folder}/` : "";

	return `cdn/stories/${folderPath}${cleanPath}`;
};
